import { ListPaginationMeta } from "utils/helpers/pagination";

export interface HydraulicManufacturerRow {
  hydraulicWallManufacturerId: string;
  hydraulicWallManufacturerName?: string;
}

export interface HydraulicManufacturerForm {
  code: string;
  description: string;
}

export enum FieldType {
  String = "string",
  Number = "number",
}

export const FieldValues: Record<keyof HydraulicManufacturerForm, FieldType> = {
  code: FieldType.String,
  description: FieldType.String,
};

export type HydraulicManufacturerListMeta = ListPaginationMeta;

export interface HydraulicManufacturerListResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: Array<{
    hydraulicWallManufacturerId: string;
    hydraulicWallManufacturerName?: string;
  }>;
  meta?: HydraulicManufacturerListMeta;
}

export interface HydraulicManufacturerUpdate {
  id: string;
  hydraulicWallManufacturerName: string;
}

export interface HydraulicManufacturerDetailResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: {
    hydraulicWallManufacturerId: string;
    hydraulicWallManufacturerName?: string;
  };
}

export interface HydraulicManufacturerState {
  loading: boolean;
  saving: boolean;
  list: HydraulicManufacturerRow[];
  page: number;
  perPage: number;
  meta: HydraulicManufacturerListMeta;
  error: string | null;
  isAddModalOpen: boolean;
  form: HydraulicManufacturerForm;
  detail: HydraulicManufacturerRow | null;
  detailLoading: boolean;
  detailError: string | null;
}
